import React, { useState } from "react";
import { Link } from "react-router-dom";
import { notification } from "antd";
import moment from "moment";

import SmartRtpTablePage from "./components/SmartRtpTablePage";
import { REPORT_STATUS_TABS } from "./config";
import {
  generateReports,
  getSavedReports,
} from "../../../controllers/V1/smartRtp/smartRtpController";

export default function SmartRtpReportsPage() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [generating, setGenerating] = useState(false);

  const handleGenerate = async () => {
    if (generating) return;
    setGenerating(true);
    try {
      const res = await generateReports({ includePerGame: true });
      if (res.status === true) {
        notification.success({ message: "Reports captured for today" });
        setRefreshKey((prev) => prev + 1);
      } else {
        notification.error({ message: res.message || "Failed to capture reports" });
      }
    } catch (error) {
      notification.error({ message: "Failed to capture reports" });
    } finally {
      setGenerating(false);
    }
  };

  return (
    <SmartRtpTablePage
      key={refreshKey}
      title="Smart RTP Reports"
      activeKey="reports"
      fetchData={getSavedReports}
      statusTabs={REPORT_STATUS_TABS}
      searchFields={["report_type", "title", "report_key"]}
      exportFileName="Smart RTP Reports"
      actions={
        <button
          type="button"
          className="btn btn-dark"
          disabled={generating}
          onClick={handleGenerate}
        >
          {generating ? "Generating..." : "Generate Reports"}
        </button>
      }
      columns={[
        { key: "report_type", label: "Report Type" },
        { key: "title", label: "Title" },
        {
          key: "orders",
          label: "Orders",
          render: (row) => row?.totals?.orders || row?.metrics?.total_orders || 0,
        },
        {
          key: "stake",
          label: "Sales (Stake)",
          render: (row) => row?.totals?.stake || row?.metrics?.total_stake || 0,
        },
        {
          key: "rewards",
          label: "Prize Distributed",
          render: (row) => row?.totals?.rewards || row?.metrics?.total_rewards || 0,
        },
        {
          key: "rtp",
          label: "RTP %",
          render: (row) => `${row?.totals?.actual_rtp || row?.metrics?.actual_rtp || 0}%`,
        },
        { key: "status", label: "Status" },
        { key: "generated_by", label: "Generated By" },
        {
          key: "generated_at",
          label: "Generated At",
          render: (row) =>
            row?.generated_at ? moment(row.generated_at).format("DD-MM-YYYY hh:mm A") : "-",
        },
        {
          key: "actions",
          label: "Action",
          render: (row) => (
            <Link to={`/smart-rtp/reports/details?editId=${row._id}`}>View</Link>
          ),
        },
      ]}
    />
  );
}
